/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Delete_ConfirmInputs */

const en_admin_posts_delete_confirm = /** @type {(inputs: Admin_Posts_Delete_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete this post?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete this post?" |
*
* @param {Admin_Posts_Delete_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_delete_confirm = /** @type {((inputs?: Admin_Posts_Delete_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Delete_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_delete_confirm(inputs)
});
export { admin_posts_delete_confirm as "admin.posts.delete_confirm" }